import { Capacitor, CapacitorHttp } from '@capacitor/core';

// Tokenização de cartão do Pagar.me (público, via appId/public key).
// Web: usa fetch normal (inalterado). Android/iOS (Capacitor WebView): usa HTTP NATIVO
// (CapacitorHttp) SOMENTE para esta chamada, contornando o bloqueio de CORS do WebView em
// https://api.pagar.me/core/v5/tokens. NUNCA envia Authorization/secret — apenas o appId.
// Fluxo: Dispositivo → Pagar.me → token → backend JATOO (o PAN/CVV nunca passa pelo backend).
const PAGARME_TOKENS_URL = 'https://api.pagar.me/core/v5/tokens';
const onlyDigits = (s) => (s || '').replace(/\D/g, '');

function buildBody(card) {
  const [mm, yy] = (card.exp || '').split('/').map((s) => s.trim());
  return {
    type: 'card',
    card: {
      number: onlyDigits(card.number),
      holder_name: (card.holder_name || '').trim(),
      exp_month: parseInt(mm, 10),
      exp_year: parseInt(yy && yy.length === 2 ? `20${yy}` : yy, 10),
      cvv: onlyDigits(card.cvv),
    },
  };
}

function extractToken(data) {
  const parsed = typeof data === 'string' ? JSON.parse(data || '{}') : (data || {});
  if (!parsed.id) {
    throw new Error(parsed?.message || parsed?.errors?.[0]?.message || 'Cartão inválido');
  }
  return parsed.id; // token_...
}

export async function tokenizeCardPagarme(publicKey, card) {
  const url = `${PAGARME_TOKENS_URL}?appId=${encodeURIComponent(publicKey)}`;
  const body = buildBody(card);

  if (Capacitor.isNativePlatform()) {
    const resp = await CapacitorHttp.post({
      url,
      headers: { 'Content-Type': 'application/json' },
      data: body,
    });
    const ok = resp && resp.status >= 200 && resp.status < 300;
    if (!ok) {
      const d = typeof resp?.data === 'string' ? (() => { try { return JSON.parse(resp.data); } catch { return {}; } })() : (resp?.data || {});
      throw new Error(d?.message || d?.errors?.[0]?.message || 'Cartão inválido');
    }
    return extractToken(resp.data);
  }

  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.message || data?.errors?.[0]?.message || 'Cartão inválido');
  }
  return extractToken(data);
}
